
import Vuex from 'vuex'

export const store =  new Vuex.Store({
	state: {
		rightView: 'item-details',
		prop1: '',
		prop2: '',
		prop3: [],

		prodID: '',

		productList: [],
		productComp: '0',

		detailsList: [],
		detailsComp: '0',

		itemProductList: [],
		itemProductComp: '0',

		itemList: [],
		itemComp: '0',
	},

	mutations: {
		setRightView(state, payload) { state.rightView = payload.name; state.prop1 = payload.prop1; state.prop2 = payload.prop2; state.prop3 = payload.prop3 },

		setProducts(state, payload) { state.productList = payload.info; state.productComp = payload.info1; },
		setProductsComp(state, payload) { state.productComp = payload.info1; },

		setDetails(state, payload) { state.detailsList = payload.info; state.detailsComp = payload.info1; },
		setDetailsComp(state, payload) { state.detailsComp = payload.info1; },

		setItemProducts(state, payload) { state.itemProductList = payload.info; state.itemProductComp = payload.info1; },
		setItemProductsComp(state, payload) { state.itemProductComp = payload.info1; },

		setItems(state, payload) { state.itemList = payload.info; state.itemComp = payload.info1; },
		setItemsComp(state, payload) { state.itemComp = payload.info1; },

		setProductID(state, payload) { state.prodID = payload.prod },
  	},

	actions: {
		getRightView(context, payload) { context.commit("setRightView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2, prop3: payload.prop3 })  },
		getAllProducts(context, payload) {
			context.commit("setProductsComp", { info1: '0' }) 
			axios.get('/admin/utility/product/getallproducts')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setProducts", { info: b, info1: '1' }) 
	          	});
	    },
		getItemDetails(context, payload) {
			context.commit("setDetailsComp", { info1: '0' }) 
			axios.get('/admin/utility/item/getitemdetails/' + payload.prod)
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setDetails", { info: b, info1: '1' }) 
	          	});
	    },
	    getAllItemProducts(context, payload) {
			context.commit("setItemProductsComp", { info1: '0' }) 
			axios.get('/admin/utility/item/getitemproducts/' + payload.prod)
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setItemProducts", { info: b, info1: '1' }) 
	          	});
	    },
	    getAllItems(context, payload) {
			context.commit("setItemsComp", { info1: '0' }) 
			axios.get('/admin/utility/product/getallitems')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setItems", { info: b, info1: '1' }) 
	          	});
	    }
	}

})